export default `:host {
  display: block;
  position: fixed;
  transition: box-shadow var(--ids-motion-duration) var(--ids-motion-ease), transform var(--ids-motion-duration) var(--ids-motion-ease);
}

:host([hidden]) {
  display: none;
}

:host([edge=bottom]) {
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(100%);
}

:host([edge=bottom][visible]) {
  transform: translateY(0);
}

:host([edge=start]:not([dir])) {
  bottom: 0;
  left: 0;
  top: 0;
  transform: translateX(-100%);
}

:host([edge=start][visible]) {
  transform: none;
}

:host([dir=rtl][edge=start]) {
  bottom: 0;
  right: 0;
  top: 0;
  transform: translateX(100%);
}

:host([dir=rtl][edge=start][visible]) {
  transform: none;
}

.ids-drawer {
  height: 100%;
  width: 100%;
}
.ids-drawer.type-action-sheet {
  background-color: var(--ids-drawer-action-sheet-color-background);
  box-shadow: var(--ids-drawer-action-sheet-shadow);
  color: var(--ids-drawer-action-sheet-color-text);
  padding: var(--ids-space-12);
  margin: 0 auto;
  max-height: 70vh;
  max-width: 480px;
  min-height: 150px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.ids-drawer.type-app-menu {
  background-color: var(--ids-drawer-app-menu-color-background);
  border-inline-end: 1px solid var(--ids-drawer-app-menu-color-border);
  color: var(--ids-drawer-app-menu-color-text);
  min-width: var(--ids-drawer-width);
  width: var(--ids-drawer-width);
}
.ids-drawer.type-app-menu ::slotted(ids-text) {
  color: inherit;
}
.ids-drawer.type-app-menu.visible {
  box-shadow: var(--ids-drawer-app-menu-shadow);
}
@media (min-width: 927px) {
  .ids-drawer.type-app-menu.visible {
    box-shadow: none;
  }
}
.ids-drawer.type-module-nav {
  background-color: var(--ids-module-nav-background-color);
  color: var(--ids-module-nav-text-color);
}

:host {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-basis: max-content;
  position: relative;
  z-index: var(--ids-module-nav-bar-z-index);
}

:host([pinned]) ::slotted(ids-separator) {
  visibility: hidden;
}

.ids-module-nav-bar {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: stretch;
  padding-block-start: var(--ids-module-nav-bar-padding-top);
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) {
  pointer-events: none;
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-bar-main {
  width: 0;
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-bar-detail {
  width: 0;
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-footer {
  display: none;
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-search-wrapper {
  display: none;
}
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-separator,
.ids-module-nav-bar:not(.display-mode-collapsed):not(.display-mode-expanded) .ids-module-nav-user-separator {
  visibility: hidden;
}
.ids-module-nav-bar:not(.display-mode-expanded) .accordion-header .ids-text {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-module-nav-bar .ids-module-nav-expander {
  position: relative;
  top: 1px;
}
.ids-module-nav-bar.display-mode-collapsed:not(.show-detail) .ids-module-nav-bar-detail, .ids-module-nav-bar.display-mode-expanded:not(.show-detail) .ids-module-nav-bar-detail {
  display: none;
}
.ids-module-nav-bar.display-mode-collapsed.show-detail .ids-module-nav-bar-main, .ids-module-nav-bar.display-mode-expanded.show-detail .ids-module-nav-bar-main {
  border-inline-end: 1px solid var(--ids-module-nav-border-color);
}
.ids-module-nav-bar.display-mode-collapsed.show-detail .ids-module-nav-bar-detail, .ids-module-nav-bar.display-mode-expanded.show-detail .ids-module-nav-bar-detail {
  width: var(--ids-module-nav-submenu-size);
}
.ids-module-nav-bar.display-mode-collapsed {
  border-inline-end: 1px solid var(--ids-module-nav-border-color);
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-separator,
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-user-separator {
  visibility: hidden;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper {
  display: flex;
  justify-content: center;
  padding: 0;
  position: relative;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper ::slotted(ids-search-field) {
  display: none;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper .standalone-search-icon {
  color: var(--ids-module-nav-text-color) !important;
  cursor: pointer;
  margin: var(--ids-module-nav-item-collapsed-general-space-size) auto;
  border-radius: var(--ids-module-nav-common-border-radius);
  height: var(--ids-module-nav-item-collapsed-size);
  width: var(--ids-module-nav-item-collapsed-size);
  box-sizing: border-box;
  position: relative;
  transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper .standalone-search-icon svg {
  width: 20px;
  height: 20px;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper .standalone-search-icon:hover {
  color: var(--ids-module-nav-text-hover-color) !important;
  background-color: var(--ids-module-nav-item-hover-bg-color);
  transform: scale(1.05);
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-search-wrapper .standalone-search-icon:active {
  transform: scale(0.95);
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-bar-main {
  width: var(--ids-module-nav-collapsed-size);
  transition: width 0.2s ease-in-out;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-item {
  height: 32px;
  margin: 4px 8px;
  padding: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-item > .icon {
  width: 16px;
  height: 16px;
  margin: 0;
  position: absolute;
  left: 8px;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-item ::slotted(ids-text),
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-item .ids-text,
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-item span {
  display: none;
}
.ids-module-nav-bar.display-mode-collapsed .ids-module-nav-settings {
  padding-block-end: 28px;
}
.ids-module-nav-bar.display-mode-expanded {
  border-right: 1px solid var(--ids-module-nav-border-color);
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-search-wrapper {
  padding-inline: var(--ids-module-nav-accordion-gutter-size);
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-bar-main {
  width: var(--ids-module-nav-expanded-size);
  transition: width 0.2s ease-in-out;
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-item {
  height: 32px;
  margin: 4px 8px;
  padding: 0 8px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-item > .icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-item ::slotted(ids-text),
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-item .ids-text,
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-item span {
  display: block;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.25s ease 0.1s;
}
.ids-module-nav-bar.display-mode-expanded.show-detail .ids-module-nav-bar-detail {
  width: var(--ids-module-nav-submenu-size);
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-settings-wrapper {
  padding-inline-start: 0;
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-settings {
  padding-block-end: 24px;
}
.ids-module-nav-bar.display-mode-expanded .ids-module-nav-main + .ids-module-nav-separator {
  display: block;
}
.ids-module-nav-bar:not(.filterable) .ids-module-nav-search-wrapper {
  display: none;
  pointer-events: none;
}
.ids-module-nav-bar:not(.pinned) {
  overflow: auto;
}
.ids-module-nav-bar:not(.pinned) .ids-module-nav-footer {
  flex-grow: 1;
}
.ids-module-nav-bar.pinned {
  overflow: hidden;
}
.ids-module-nav-bar.pinned .ids-module-nav-main,
.ids-module-nav-bar.pinned .ids-module-nav-search-no-results {
  flex-grow: 1;
  overflow: auto;
}
.ids-module-nav-bar.pinned .ids-module-nav-footer {
  flex-grow: 0;
}

.ids-module-nav-bar-main {
  box-sizing: border-box;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  background-color: var(--ids-module-nav-bg-color);
  color: var(--ids-module-nav-text-color);
  height: 100%;
  transition: width 0.2s ease-in-out;
  will-change: width;
  overflow: hidden;
}

.ids-module-nav-bar-detail {
  box-sizing: border-box;
  background-color: var(--ids-module-nav-detail-bg-color);
  border-inline-end: 1px solid var(--ids-module-nav-border-color);
  height: 100%;
  transition: width 0.2s ease-in-out;
  will-change: width;
  overflow: hidden;
}

.ids-module-nav-branding,
.ids-module-nav-footer,
.ids-module-nav-header,
.ids-module-nav-search,
.ids-module-nav-user {
  flex-grow: 0;
}

.ids-module-nav-content {
  overflow: auto;
  flex-grow: 1;
}

.ids-module-nav-user {
  padding: var(--ids-space-4xl);
}

.ids-module-nav-search {
  padding: var(--ids-space-lg);
}

.ids-module-nav-search-no-results {
  display: none;
}
.ids-module-nav-search-no-results.visible {
  display: block;
}

::slotted(ids-icon[slot=avatar]) {
  padding: var(--ids-space-lg);
}

::slotted(img[slot=avatar]) {
  border-radius: var(--ids-border-radius-round);
  height: 40px;
  width: 40px;
}

::slotted(ids-toolbar) {
  padding-inline: var(--ids-space-lg);
  margin-block-end: var(--ids-space-lg);
}

::slotted(ids-tooltip) {
  display: block;
  white-space: nowrap;
}

::slotted(ids-tooltip::part(tooltip)) {
  display: flex;
}

::slotted([slot=expander]) {
  border-bottom: 1px solid var(--ids-module-nav-border-color);
  margin-block-start: -2px;
}

:host([dir=rtl]) .ids-module-nav-bar.display-mode-collapsed {
  border-inline-start: 1px solid var(--ids-module-nav-border-color);
  border-inline-end: none;
}
:host([dir=rtl]) .ids-module-nav-bar.display-mode-expanded {
  border-left: 1px solid var(--ids-module-nav-border-color);
  border-right: none;
}
:host([dir=rtl]) .ids-module-nav-bar.display-mode-expanded .ids-module-nav-item > .icon {
  margin-left: 8px;
  margin-right: 0;
}
:host([dir=rtl]) .ids-module-nav-bar.display-mode-collapsed.show-detail .ids-module-nav-bar-main, :host([dir=rtl]) .ids-module-nav-bar.display-mode-expanded.show-detail .ids-module-nav-bar-main {
  border-inline-start: 1px solid var(--ids-module-nav-border-color);
  border-inline-end: none;
}
:host([dir=rtl]) .ids-module-nav-bar-detail {
  border-inline-start: 1px solid var(--ids-module-nav-border-color);
  border-inline-end: none;
}
:host([dir=rtl]) ::slotted(ids-icon[icon*=chevron-left]) {
  transform: scaleX(-1);
}
:host([dir=rtl]) ::slotted(ids-icon[icon*=chevron-right]) {
  transform: scaleX(-1);
}
:host([dir=rtl]) ::slotted(ids-icon[icon*=expand-app-tray]) {
  transform: scaleX(-1);
}
:host([dir=rtl]) ::slotted(ids-icon[icon*=collapse-app-tray]) {
  transform: scaleX(-1);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
